export default function HowItWorks() {
  const steps = [
    { num: '01', title: 'Connect Wallet', desc: 'Connect MetaMask. We auto-switch to VDC Chain (882022) for you.', icon: '🦊' },
    { num: '02', title: 'Fill Token Details', desc: 'Enter name, symbol, supply, decimals. Choose features — tax, mint, burn, cooldown etc.', icon: '📝' },
    { num: '03', title: 'Pay & Deploy', desc: 'Pay 1 VDC deploy fee. Sign transaction in MetaMask. Token deploys instantly on-chain.', icon: '🚀' },
    { num: '04', title: 'Add Liquidity', desc: 'Get contract address, go to VDC DEX, add liquidity and start trading!', icon: '💧' },
  ]

  return (
    <section style={{
      padding: '80px 24px',
      background: 'radial-gradient(ellipse at center, rgba(124,58,237,0.05) 0%, transparent 70%)'
    }}>
      <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <h2 style={{ fontSize: 'clamp(28px, 4vw, 48px)', fontWeight: '800', marginBottom: '16px' }}>
            How It <span className="gradient-text">Works</span>
          </h2>
          <p style={{ color: '#64748b', fontSize: '16px' }}>4 simple steps to launch your token</p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '24px' }}>
          {steps.map((step, i) => (
            <div key={i} style={{ textAlign: 'center', position: 'relative' }}>
             { i < steps.length - 1 && (
  <div style={{
    position: 'absolute',
    top: '40px',
    right: '-12px',
    color: '#374151',
    fontSize: '20px',
    zIndex: 1
  }}>→</div>
)}
              <div className="card" style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '40px', marginBottom: '16px' }}>{step.icon}</div>
                <div style={{
                  fontSize: '12px', fontWeight: '700', color: '#7c3aed',
                  letterSpacing: '2px', marginBottom: '12px'
                }}>STEP {step.num}</div>
                <h3 style={{ fontWeight: '700', marginBottom: '12px', color: '#e2e8f0' }}>{step.title}</h3>
                <p style={{ color: '#64748b', fontSize: '13px', lineHeight: '1.6' }}>{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
